import React, { useEffect, useState } from 'react';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { Grid, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import 'leaflet/dist/leaflet.css';
import './holdings.ui.scss';
import Leaflet, { LatLngBounds, latLngBounds } from 'leaflet';
import { getHoldings } from '../../../services/map.service';
import { showAxiosMessageError } from '../../../utils/error-message.util';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { HoldingDto } from '../../../services/dtos/holding.dto';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';

//Gestion des icons
Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: iconRetinaUrl,
    iconUrl: iconUrl,
    shadowUrl: shadowUrl,
});

/**
 * Ui pour la page patrimoine
 * @constructor
 */
export default function HoldingsUi(
    props: Readonly<{
        mandate?: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto;
    }>
) {
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    // patrimoines
    const [holdings, setHoldings] = useState<Array<HoldingDto>>();
    //bounds
    const [bounds, setBounds] = useState<LatLngBounds>();

    //Récupération des patrimoines au chargement de la page
    useEffect(() => {
        let isMounted = true;
        //Action s'il y a un mandat
        if (props.mandate) {
            getHoldings(props.mandate.id)
                .then(result => {
                    if (isMounted) {
                        setHoldings(result);
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des patrimoines');
                    showAxiosMessageError(error, showMessage);
                });
        }

        //unamount
        return () => {
            isMounted = false;
        };
    }, [showMessage, props.mandate]);

    //Gesiton des données patrimoie pour la map
    useEffect(() => {
        if (holdings && holdings.length > 0) {
            let markerBounds = latLngBounds([]);
            holdings.forEach(holding => {
                markerBounds.extend([holding.coordinateX, holding.coordinateY]);
            });
            setBounds(markerBounds);
            return;
        }

        setBounds(undefined);
    }, [holdings]);

    //Retourne la vue
    return (
        <Grid container className={'tab-content holding'} rowSpacing={1}>
            <Grid item xs={12}>
                <Typography variant="h3" className={'title'}>
                    <LocationOnIcon /> Patrimoine
                </Typography>
            </Grid>
            {/* On affiche la carte dans la page */}
            <Grid item xs={0} sm={1} />
            <Grid item xs={12} sm={10}>
                <MapContainer
                    bounds={bounds || undefined}
                    center={bounds ? undefined : [48.2924219, 4.0586248]}
                    zoom={bounds ? undefined : 13}
                    scrollWheelZoom={true}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {holdings?.map(value => (
                        <Marker
                            position={[value.coordinateX, value.coordinateY]}
                            key={value.coordinateX + value.coordinateY}
                        >
                            <Popup>
                                {value.category}
                                <br />
                                {value.name}
                            </Popup>
                        </Marker>
                    ))}
                </MapContainer>
            </Grid>
            <Grid item xs={0} sm={1} />
        </Grid>
    );
}
